import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { AlertService } from '../shared/alert/alert.service';
import { SpinnerService } from '../shared/spinner/spinner.service';

@Component({
    selector: 'bypassAuth',
    template: ''
})

export class BypassAuthComponent implements OnInit {
    bypassThirdParty: string;
    bypassKey: string;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private spinnerService: SpinnerService
    ) {}

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.bypassThirdParty = params['bypassThirdParty'];
            this.bypassKey = params['bypassKey'];
            this.bypass();
        });
    }

    private bypass(): void {
        this.spinnerService.start('Connexion');
        this.authenticationService.bypass(this.bypassThirdParty, this.bypassKey)
          .then(function(response){
            if (response.success) {
              this.router.navigate(['']);
            } else {
              this.alertService.error(response.message);
            }
            this.spinnerService.stop();
          }.bind(this));
    }
}



// WEBPACK FOOTER //
// ./src/app/bypassAuth/bypass-auth.component.ts